import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PropTypes from "prop-types";

function StaticModal(props) {


    return (

        <Modal
            show={props.show}
            onHide={props.handleClose}
            className='text-justify'
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header className='justify-content-center' closeButton >
                <Modal.Title>Potential Issue Identified</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Your test kit has been identified as part of a potential returns label issue. If the postcode on your returns envelope <strong>does NOT begin with <span>{`‘TS22’`}</span>
                </strong>, please contact <a className='berry-link' href="mailto:care@myhealthchecked.com">
                        care@myhealthchecked.com</a> for us to provide you with a new returns label as soon as possible.</p>

                <p>If the postcode on your returns envelope <strong>DOES begin with <span>{`‘TS22’`}</span>
                </strong>, please disregard this message and return your sample as normal.</p>
            </Modal.Body >
            <Modal.Footer className='justify-content-center'>
                <Button variant="primary" onClick={props.handleClick}>I have read and understood</Button>
            </Modal.Footer>
        </Modal >
    );
}

StaticModal.propTypes = {
    show: PropTypes.bool,
    handleClick: PropTypes.func,
    handleClose: PropTypes.func,
};

export default StaticModal;
